import { ElevatorSharp } from '@mui/icons-material';
import {api as axios} from '../../shared/axios';
import { API_URL } from '../../shared/config';
import Cookies from "js-cookie";


export const addHuaweiServer = async (serverDetails, plantId) => {
    
    try { 
        const request = await axios.post(`${API_URL}/plant/${plantId}/server/huawei/add/`, serverDetails);

        return { data: request.data, error: undefined };

    } catch (error) {
        if(error?.response?.data?.error.toLowerCase().includes("duplicated server name")){
            let serverType = serverDetails?.type.toUpperCase();
            return { data: undefined, error: `Duplicate server type, you already have another ${serverType} server` };
        }else{
            return { data: undefined, error: error.response.data.error };
        }
  }
}

export const editHuaweiServer = async (serverDetails,plantId) => {
    try {
        const request = await axios.post(`${API_URL}/plant/${plantId}/server/huawei/edit/`, serverDetails);

        return { data: request.data, error: undefined };

    } catch (error) {
        if(error?.response?.data?.error.toLowerCase().includes("duplicated server name")){
            let serverType = serverDetails?.type.toUpperCase();
            return { data: undefined, error: `Duplicate server type, you already have another ${serverType} server` };
        }else{
            return { data: undefined, error: error.response?.data?.error };
        }
  }
}

export const huaweiLogin = async (data) => {
    try {
            const request = await axios.post(`${API_URL}/thirdparty/huawei/login/`, data);
            // console.log(request.data['XSRF-TOKEN'])

            if(request.data['XSRF-TOKEN']){
                //expires in 12hrs
                // Cookies.set('h-csrfToken', request.data['XSRF-TOKEN'],{ expires: 0.5 }); 
                return {status: "Connection was successful", success: true, token:request.data['XSRF-TOKEN']}
            }

            if(request.data.error){
                return {status: request?.data.error, success: false}
            }
            return { data: "Connection failed, please try again", error: undefined };
    }
    catch (error) {
        return {status: error.response?.data?.error, success: false}
    }
};


export const huaweiStationList = async (username) => {
    // const req_data ={
    //     "xsrf-token": csrfToken,
    //     "request_body": {},
    //     "url": "https://sg5.fusionsolar.huawei.com/thirdData/getStationList"
    //   }

    try {
        const request = await axios.post(`${API_URL}/plant/huawei/stations/`, {username: username});
        if(request?.data?.error){
            return {status: request?.data.error, success: false}
        }else{
            return {data: request?.data, success: true}
        }
    }
    catch (error) {
        return {status: error?.response?.data?.error, success: false}
    }
};

export const huaweiDeviceList = async ({csrfToken, stationCode}) => {
    const req_data ={
        "xsrf-token": csrfToken,
        "request_body": {
            "stationCodes": stationCode
        },
        "url": "https://sg5.fusionsolar.huawei.com/thirdData/getDevList"
      }

    try {
        const request = await axios.post(`${API_URL}/thirdparty/huawei/api/`, req_data);
        return request?.data;
    }
    catch (error) {
        return {status: error?.response?.data?.error, success: false}
    }
};